export function useArrayUtils() {
    function arrayToCommaSeparatedString(arr: string[]): string {
        const lastComma = /,\s(?=[^,]*$)/;

        return arr.join(', ').replace(lastComma, ' & ');
    }

    return {
        arrayToCommaSeparatedString,
    };
}
